import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

// Actions
import { setFavorite } from "redux/game/slice";

// Api
import { gamesApi } from "redux/game/api";

// Components
import ButtonFavorite from "components/atoms/ButtonFavorite";

// Hooks
import { useGTM } from "hooks/useGTM";

// Selectors
import * as gameSelector from "redux/game/selectors";
import { FavoritesResponseType } from "types/Games";

const ButtonFavoriteContainer = () => {
  const currentGame = useSelector(gameSelector.currentGame);
  const currentAliasGame = useSelector(gameSelector.currentAliasGame);
  const favorite = useSelector(gameSelector.favorite);
  const dispatch = useDispatch();
  const GTM = useGTM();
  const [toggleFavorite] = gamesApi.useToggleFavoriteMutation();
  const { data, refetch } = gamesApi.useFavoritesQuery();
  const favoriteGames = (data as FavoritesResponseType)?.favoriteGames || data;

  useEffect(() => {
    const favorites = favoriteGames?.map((el) => el.urlAlias);
    if (favorites?.includes(currentAliasGame)) {
      dispatch(setFavorite(true));
    } else {
      dispatch(setFavorite(false));
    }
  }, [currentAliasGame, dispatch, favoriteGames]);

  async function favoriteHandle() {
    if (currentAliasGame) {
      try {
        const game =
          currentGame ||
          favoriteGames?.find((g) => g.urlAlias === currentAliasGame) ||
          null;
        if (currentAliasGame) {
          const response = await toggleFavorite({ urlAlias: currentAliasGame });
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          if (response.data) {
            dispatch(setFavorite(!favorite));
            refetch();
            if (favorite) {
              GTM.clickRemoveFavorite(game);
            } else {
              GTM.clickAddFavorite(game);
            }
          }
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    }
  }

  // eslint-disable-next-line react/jsx-handler-names, react/jsx-no-bind
  return <ButtonFavorite favorite={favorite} onClick={favoriteHandle} />;
};

export default ButtonFavoriteContainer;
